export default class Upload {

	constructor(name) {

		window[name] = this.data()
	}

	data() {
		return {
			loading: true,
			saving: false,
			groupname: null,
			fileName: null,
			Uploads: [],
			text: '',
			itemId: null,
			testReportId: null,
			deleting: null,


			init(itemId, testReportId) {
				var vm = this;
				vm.itemId = itemId
				vm.testReportId = testReportId

				var xhttp = new XMLHttpRequest();
				var csrf = document.querySelector('meta[name="csrf-token"]').getAttribute('content')
				vm.loading = true

				xhttp.onreadystatechange = function() {
					if (this.readyState == 4 && this.status == 200) {
						vm.Uploads = JSON.parse(this.responseText);
						vm.loading = false
					}

					if( vm.Uploads == undefined){
						vm.Uploads = [];
					}
				}
				
				xhttp.open('get', '/api/item/'+ itemId + '/test-report/'+ testReportId + '/upload', true);
				
				xhttp.setRequestHeader('X-CSRF-TOKEN', csrf);
				xhttp.setRequestHeader('Content-type', 'application/json;charset=utf-8');
				xhttp.send();
			},

			UploadFile(itemId, testReportId){
				
				var vm = this;
				vm.saving = true;
				var xhttp = new XMLHttpRequest();
				var csrf = document.querySelector('meta[name="csrf-token"]').getAttribute('content')
				var input = document.querySelector('input[type="file"]#fileField')
				var data = new FormData()
				data.append('file', input.files[0])

				xhttp.onreadystatechange = function() {
					if (this.readyState == 4 && this.status == 200) {
						vm.init(itemId,testReportId)
						vm.saving = false
					}
				}

				xhttp.open('POST', '/api/item/'+ itemId + '/test-report/'+ testReportId + '/upload' , true);
				xhttp.setRequestHeader('X-CSRF-TOKEN', csrf);
				xhttp.send( data );
			},

			destroy(index){
				var vm = this;
				vm.loading = true;
				vm.deleting = index;
				var xhttp = new XMLHttpRequest();
				xhttp.onreadystatechange = function() {
					if (this.readyState == 4 && this.status == 200) {
						vm.init(vm.itemId,vm.testReportId)
						vm.deleting = null
					}
				}
				console.log( '/api/item/' + vm.itemId + '/test-report/' + vm.testReportId + '/upload/' + vm.Uploads[index].id);
				xhttp.open('DELETE', '/api/item/' + vm.itemId + '/test-report/' + vm.testReportId + '/upload/' + vm.Uploads[index].id , true);
				var csrf = document.querySelector('meta[name="csrf-token"]').getAttribute('content')
				xhttp.setRequestHeader('X-CSRF-TOKEN', csrf);
				xhttp.setRequestHeader('Content-type', 'application/json;charset=utf-8');
				xhttp.send(JSON.stringify( {'term': 1 , 'Uploads': vm.Uploads } ) );
				
			}
			

		}
	}
}